module.exports = __webpack_public_path__ + "star.430fe1a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/retailers/star.png
// module id = 1745
// module chunks = 0